






























import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import CommonHubSelector from '@/components/CommonHubSelector.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';
import { magicUniqueColor, pieChartColors } from '@/useApexchartsColor';

const DonutExpenseByType = defineComponent({
  components: {
    CommonHubSelector,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
    resultLeased: {
      type: Function,
      default: undefined,
    },
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        timeframe: filter.monthRange,
        hubId: filter.hub && (filter.hub as any).id ? (filter.hub as any).id : undefined,
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined,
      }),
    );
    const getDataArray = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined) {
        return props.result(result.value);
      }
      return [];
    });
    const getDataLabels = computed(() => getDataArray.value?.map((item: any) => item.paymentAccount));
    const getDataAmount = computed(() => getDataArray.value?.map((item: any) => item.amount));
    const totalAmount: any = computed(() => getDataAmount.value.reduce((a: any, b: any) => a + b, 0));

    const options = computed(() => ({
      responsive: false,
      plugins: {
        legend: {
          position: 'right',
          align: 'center',
          labels: {
            generateLabels(chart: any) {
              const { data } = chart;
              if (data.labels.length && data.datasets.length) {
                const { labels: { pointStyle, color } } = chart.legend.options;

                return data.labels.map((label: string, i: number) => {
                  const meta = chart.getDatasetMeta(0);
                  const style = meta.controller.getStyle(i);

                  return {
                    text: `${toCommaFormat((data.datasets[0].data[i] * 100) / totalAmount.value)}% - ${label}`,
                    fillStyle: style.backgroundColor,
                    strokeStyle: style.borderColor,
                    fontColor: color,
                    lineWidth: style.borderWidth,
                    pointStyle,
                    hidden: !chart.getDataVisibility(i),

                    // Extra data used for toggling the correct item
                    index: i,
                  };
                });
              }
              return [];
            },
          },
        },
      },
      datasets: {
        offset: 0,
      },
    }));

    const data = computed(() => ({
      // TODO: update this to hub list later
      labels: getDataLabels.value,
      datasets: [
        {
          label: 'รายได้',
          data: getDataAmount.value,
          backgroundColor: pieChartColors,
        },
      ],
    }));

    return {
      filter,
      data,
      options,
      // rawData,
      totalAmount,
    };
  },
});

export default DonutExpenseByType;
